<template>
  <div class="batchBox">
    <el-row class="accountCon">
      <el-col class="leftCon" :span="4">
        <div class="label1">
          <i class="el-icon-collection-tag" /> 发放优惠券
          <img src="@/assets/images/triangle.png" alt />
        </div>
      </el-col>
      <el-col class="rightCon" :span="20">
        <el-form ref="detail" label-position="right" label-width="140px" :model="detail">
          <el-form-item label="发放类型:" prop="provide_type">
            <el-select
              class="w300"
              v-model="detail.provide_type"
              placeholder="请选择优惠券类型"
              @change="changeType"
            >
              <el-option
                v-for="item in options.provide_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          

          <!-- 1 会员标签 -->
          <el-form-item v-if="detail.provide_type == 1" label="会员标签:">
            <el-select
              v-model="memberLabel"
              class="w300"
              clearable
              multiple
              filterable
              placeholder="请选择会员标签"
            >
              <el-option
                v-for="item in options.memberLabel"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <!-- 2 店铺 -->
          <el-form-item v-if="detail.provide_type == 2" label="店铺:">
            <el-select
              v-model="relationShop"
              class="w300"
              clearable
              multiple
              filterable
              placeholder="请选择店铺"
            >
              <el-option
                v-for="item in options.relationShop"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>

          <!-- 3 会员等级 -->
          <el-form-item v-if="detail.provide_type == 3" label="会员等级:">
            <el-select
              v-model="memberRank"
              class="w300"
              clearable
              multiple
              filterable
              placeholder="请选择会员等级"
            >
              <el-option
                v-for="item in options.memberRank"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <!-- 4 指定客户 -->

          <el-form-item v-if="detail.provide_type == 4" label="客户:">
            <el-select
              v-model="client"
              class="w300"
              clearable
              multiple
              filterable
              remote
              :remote-method="remoteMethod"
              placeholder="请输入客户手机号"
            >
              <el-option
                v-for="item in options.client"
                :key="item.id"
                :label="item.customer_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- 5 客户筛查 完整筛选区域 -->
          <el-form-item v-if="detail.provide_type == 5" label="筛选条件:" >    
            <div class="filter-row">
              <span class="filter-title">是否短信通知：</span>
             <el-radio-group v-model="search.is_send">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是（最多只能发送200个顾客）</el-radio>
            </el-radio-group>
            </div>
          <div class="filter-row">
              <span class="filter-title">指定会员：</span>
              <el-select
                v-model="search.customer_ids"
                class="w300"
                clearable
                multiple
                filterable
                remote
                :remote-method="remoteMethod"
                placeholder="请输入客户手机号"
              >
                <el-option
                  v-for="item in options.client"
                  :key="item.id"
                  :label="item.customer_name + '(' + item.telephone + ')'"
                  :value="item.id"
                />
              </el-select>
            </div>
            
            <div class="filter-row" v-if="(userInfo.group_id == 96 || [1, 1737, 1901, 1916, 1917, 1752, 1754].includes(userInfo.id)) && !shop_id">
              <span class="filter-title">市场归属：</span>
              <el-select
                class="w300"
                v-model="search.market_list"
                multiple
                filterable
                placeholder="请选择市场名称"
              >
                <el-option
                  v-for="item in options.marketList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">门店归属：</span>
              <el-select
                class="w300"
                v-model="search.shop_list"
                multiple
                filterable
                placeholder="请选择门店归属"
              >
                <el-option
                  v-for="item in options.shopList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">客服归属：</span>
              <el-select
                class="w300"
                v-model="search.operator_id"
                multiple
                filterable
                placeholder="请选择客服名称"
              >
                <el-option
                  v-for="item in options.adminList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">护理师归属：</span>
              <el-select
                class="w300"
                v-model="search.nurse_id"
                multiple
                filterable
                placeholder="请选择护理师名称"
              >
                <el-option
                  v-for="item in options.personList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                     <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.shopName }}</span>
                  </el-option>
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">会员等级：</span>
              <el-select
                class="w300"
                v-model="search.memberRank"
                multiple
                filterable
                placeholder="请选择会员等级"
              >
                <el-option
                  v-for="item in options.memberRank"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">性别：</span>
              <el-select
                class="w300"
                v-model="search.sex"
                multiple
                placeholder="请选择性别"
              >
                <el-option label="男" :value="1" />
                <el-option label="女" :value="2" />
              </el-select>
            </div>

            <div class="filter-row">
              <span class="filter-title">保有顾客：</span>
              <el-select
                class="w300"
                v-model="search.retained"
                multiple
                placeholder="请选择客户保有类型"
              >
                <el-option label="A类" value="A" />
                <el-option label="B类" value="B" />
                <el-option label="C类" value="C" />
                <el-option label="D类" value="D" />
                <el-option label="E类" value="E" />
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">流失顾客：</span>
              <el-select
                class="w300"
                v-model="search.lost"
                multiple
                placeholder="请选择客户流失类型"
              >
                <el-option label="A类" value="A" />
                <el-option label="B类" value="B" />
                <el-option label="C类" value="C" />
                <el-option label="D类" value="D" />
                <el-option label="E类" value="E" />
              </el-select>
            </div>
            <div class="filter-row">
              <span class="filter-title">流失预警客户：</span>
              <el-select
                class="w300"
                v-model="search.lost_warning"
                multiple
                placeholder="请选择客户流失预警类型"
              >
                <el-option label="A类" value="A" />
                <el-option label="B类" value="B" />
                <el-option label="C类" value="C" />
                <el-option label="D类" value="D" />
                <el-option label="E类" value="E" />
              </el-select>
            </div>

            <div class="filter-row">
              <span class="filter-title">新增时间区间：</span>
              <el-date-picker
                v-model="search.create_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div class="filter-row">
              <span class="filter-title">进店时间区间：</span>
              <el-date-picker
                v-model="search.come_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>

            <div class="filter-row">
              <span class="filter-title">未进店时间区间：</span>
              <el-date-picker
                v-model="search.no_come_times"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div class="filter-row">
              <span class="filter-title">成交时间区间：</span>
              <el-date-picker
                v-model="search.cj_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div class="filter-row">
              <span class="filter-title">未成交时间区间：</span>
              <el-date-picker
                v-model="search.no_cj_times"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div class="filter-row">
              <span class="filter-title">疤痕类型：</span>
              <el-select
                class="w300"
                v-model="search.scar_id"
                multiple
                filterable
                placeholder="请选择疤痕类型"
              >
                <el-option
                  v-for="item in options.scar_id"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>

            <div class="filter-row">
              <span class="filter-title">客户来源：</span>
              <el-select
                class="w300"
                v-model="search.source_id"
                multiple
                filterable
                placeholder="请选择客户来源"
              >
                <el-option
                  v-for="item in options.source_id"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>

            <div class="filter-row">
              <span class="filter-title">客户标签：</span>
              <el-select
                class="w300"
                v-model="search.member_label"
                clearable
                multiple
                filterable
                placeholder="请选择客户标签"
              >
                <el-option
                  v-for="item in options.member_label"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <!-- <div class="filter-row">
              <span class="filter-title">手动标签：</span>
              <el-select
                class="w300"
                v-model="search.member_label"
                clearable
                multiple
                filterable
                placeholder="请选择手动标签"
              >
                <el-option
                  v-for="item in options.member_label"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div> -->
            <div class="filter-row">
              <span class="filter-title">累计消费金额：</span>
              <el-input class="w150" v-model="search.consume_min" placeholder="最低金额"  />
              <span class="split-line"> ~ </span>
              <el-input class="w150" v-model="search.consume_max" placeholder="最高金额"  />
            </div>

            <div class="filter-row">
              <span class="filter-title">年龄区间：</span>
              <el-input class="w150" v-model="search.age_min" placeholder="最小年龄" />
              <span class="split-line"> ~ </span>
              <el-input class="w150" v-model="search.age_max" placeholder="最大年龄" />
            </div>
          </el-form-item>

          <el-button type="primary" size="mini" class="mainBtn" @click="submitForm" :loading="loading">完成，发放优惠券</el-button>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ssettingList, clientList, getGradeList, getTwoLabel, adminList } from "@/api/client";
import { provide } from "@/api/card";
import { shopPerson } from "@/api/shop";
import { staffList } from "@/api/staff";
import { getShopList } from "@/api/shop";
import { mapGetters } from "vuex";
// 【重点】Search类完全对齐template里所有v-model字段
class Search {
  // 市场、门店、客服、护理师
  market_list = [];
  is_send = 0;
  shop_list = [];
  operator_id = [];
  nurse_id = [];

  memberRank = [];
  sex = [];

  // 保有/流失/流失预警
  retained = [];
  lost = [];
  lost_warning = [];

  // 日期区间
  create_time = [];
  come_time = [];
  no_come_times = [];
  cj_time = [];
  no_cj_times = [];
  customer_ids = [];
  scar_id = [];
  source_id = [];
  member_classification = [];
  member_label = []; 
  consume_min = null;
  consume_max = null;
  age_min = null;
  age_max = null;
}

class Detail {
  id = "";
  provide_type =5;
  dataList = [];
}

class Options {
  adminList = [];
  marketList = [];
  shopList = [];
  personList = [];
  provide_type = [
    // { id: 1, name: "标签选择" },
    // { id: 2, name: "门店选择" },
    // { id: 3, name: "会员等级" },
    // { id: 4, name: "指定会员" },
    { id: 5, name: "客户筛查" }
  ];
  effective_entry = [
    { id: 0, name: "全部" },
    { id: 1, name: "是" },
    { id: 2, name: "否" }
  ];
  memberLabel = [];
  relationShop = [];
  memberRank = [];
  client = [];
  member_classification = [];
  source_id = [];
  scar_id = [];
  member_label = [];
}

export default {
  name: "issueCard",
  data() {
    return {
      shop_id: "",
      loading: false,
      search: new Search(),
      detail: new Detail(),
      options: new Options(),
      memberLabel: [],
      relationShop: [],
      memberRank: [],
      client: [],
      searchClient: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    // this.getOptioms("setting");
    this.getSetting();
    this.detail.id = this.$route.query.id;
    this.shop_id = this.$route.query.shop_id;
    this.getOptions();

  },
  methods: {
    getOptions() {
      adminList().then(res => {
        this.options.adminList = res || [];
      })
      shopPerson({ action: 'market' }).then(res => {
        this.options.marketList = res || [];
      })
      shopPerson({ action: 'shop', shop_id: this.shop_id }).then(res => {
        this.options.shopList = res || [];
      })
      staffList({ page: 1, limit: 1000000 }).then(res => {
        this.options.personList = res.list || [];
      })
    },

    // 切换发放类型重置选中项
    changeType(typeVal) {
      // 清空单选多选选中
      this.memberLabel = [];
      this.relationShop = [];
      this.memberRank = [];
      this.client = [];
      this.searchClient = [];
      // 重置所有筛选表单
      this.search = new Search();

      if (typeVal === 2 || typeVal === 5) {
        this.getOptioms("shop");
      }
      if (typeVal === 3 || typeVal === 5) {
        this.getOptioms("rank");
      }
      if (typeVal === 5) {
        this.getSetting();
      }
    },

    // 获取客户筛查所需字典
    getSetting() {
      getTwoLabel().then(res => {
        this.options.member_label = res.data;
      });
      getGradeList().then(res => {
        this.options.memberRank = res.list;
      });
      ssettingList({ page: 1, limit: 100000 }).then(res => {
        res.list.forEach(item => {
          if (item.category_id === 1) this.options.scar_id.push(item);
          if (item.category_id === 4) this.options.source_id.push(item);
          if (item.category_id === 8) this.options.member_classification.push(item);
        });
      });
    },

    // 公共字典接口
    getOptioms(type) {
      switch (type) {
        case "setting":
          ssettingList({ page: 1, limit: 100000 }).then(res => {
            res.list.forEach(item => {
              if (item.category_id === 7) this.options.memberLabel.push(item);
            });
          });
          break;
        case "shop":
          getShopList({ page: 1, limit: 100000 }).then(res => {
            this.options.relationShop = res.list;
          });
          break;
        case "rank":
          getGradeList().then(res => {
            this.options.memberRank = res.list;
          });
          break;
      }
    },

    // 远程搜索客户手机号
    remoteMethod(phone) {
      if (phone.length === 11) {
        clientList({ telephone: phone, page: 1, limit: 100000 }).then(res => {
          this.options.client = res.list;
          this.searchClient = [...new Set([...this.searchClient, ...res.list])];
        });
      }
    },

    // 提交表单
    submitForm() {
      const type = this.detail.provide_type;
      // 类型1：会员标签
      if (type === 1) {
        if (!this.memberLabel.length) return this.hintMes("会员标签");
        const selectItems = this.options.memberLabel.filter(v => this.memberLabel.includes(v.id));
        this.detail.dataList = selectItems.map(item => ({ data_id: item.id, data_name: item.name }));
        this.hint("发放此优惠券");
      }
      // 类型2：门店
      else if (type === 2) {
        if (!this.relationShop.length) return this.hintMes("店铺");
        const selectItems = this.options.relationShop.filter(v => this.relationShop.includes(v.shopId));
        this.detail.dataList = selectItems.map(item => ({ data_id: item.shopId, data_name: item.shopName }));
        this.hint("发放此优惠券");
      }
      // 类型3：会员等级
      else if (type === 3) {
        if (!this.memberRank.length) return this.hintMes("会员等级");
        const selectItems = this.options.memberRank.filter(v => this.memberRank.includes(v.id));
        this.detail.dataList = selectItems.map(item => ({ data_id: item.id, data_name: item.name }));
        this.hint("发放此优惠券");
      }
      // 类型4：指定客户
      else if (type === 4) {
        if (!this.client.length) return this.hintMes("客户");
        const selectItems = this.searchClient.filter(v => this.client.includes(v.id));
        this.detail.dataList = selectItems.map(item => ({ data_id: item.id, data_name: item.customer_name }));
        this.hint("发放此优惠券");
      }
      // 【重点】类型5：客户筛查，全部页面字段组装
      else if (type === 5) {
        const filterParams = {};

        // 1.归属类多选数组
        if (this.search.customer_ids.length) filterParams.customer_ids = this.search.customer_ids;
        if (this.search.market_list.length) filterParams.market_list = this.search.market_list;
        if (this.search.shop_list.length) filterParams.shop_list = this.search.shop_list;
        if (this.search.operator_id.length) filterParams.operator_id = this.search.operator_id;
        if (this.search.nurse_id.length) filterParams.nurse_id = this.search.nurse_id;
        if (this.search.memberRank.length) filterParams.memberRank = this.search.memberRank;
        if (this.search.sex.length) filterParams.sex = this.search.sex;

        // 2.保有/流失/流失预警分类
        if (this.search.retained.length) filterParams.retained = this.search.retained;
        if (this.search.lost.length) filterParams.lost = this.search.lost;
        if (this.search.lost_warning.length) filterParams.lost_warning = this.search.lost_warning;

        // 3.日期区间数组
        if (this.search.create_time.length) filterParams.create_time = this.search.create_time;
        if (this.search.come_time.length) filterParams.come_time = this.search.come_time;
        if (this.search.no_come_times.length) filterParams.no_come_times = this.search.no_come_times;
        if (this.search.cj_time.length) filterParams.cj_time = this.search.cj_time;
        if (this.search.no_cj_times.length) filterParams.no_cj_times = this.search.no_cj_times;

        // 4.字典多选
        if (this.search.scar_id.length) filterParams.scar_id = this.search.scar_id;
        if (this.search.source_id.length) filterParams.source_id = this.search.source_id;
        if (this.search.member_classification.length) filterParams.member_classification = this.search.member_classification;
        if (this.search.member_label.length) filterParams.member_label = this.search.member_label;

        if (this.search.consume_min !== null) filterParams.consume_min = this.search.consume_min;
        if (this.search.consume_max !== null) filterParams.consume_max = this.search.consume_max;
        if (this.search.age_min !== null) filterParams.age_min = this.search.age_min;
        if (this.search.age_max !== null) filterParams.age_max = this.search.age_max;
        if (this.search.is_send !== null) filterParams.is_send = this.search.is_send;

        if (!Object.keys(filterParams).length) {
          return this.$message.warning("至少选择一项筛选条件！");
        }
        this.detail.dataList = filterParams;
        this.hint("发放此优惠券");
      }
    },

    hintMes(text) {
      this.$message.warning(`请添加${text}哦~`);
    },

    hint(text) {
      this.$confirm(`${text}，是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.confirm();
        })
        .catch(() => this.$message.info("已取消"))
        .finally(() => {
          this.loading = false;
        });
    },

    confirm() {
      provide({ ...this.detail }).then(res => {
        this.$message.success(res.msg);
        this.$router.push("./cardList");
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.accountCon {
  background: #fff;
  position: relative;
  .leftCon {
    background: #fcfcfc;
    border-right: 1px solid #eee;
    position: absolute;
    height: 100%;
    > div {
      line-height: 48px;
      color: #fff;
      background: #9ea7b4;
      width: 100%;
      padding-left: 80px;
      font-size: 14px;
      box-sizing: border-box;
      img {
        position: absolute;
        right: -30px;
        width: 40px;
        height: 48px;
      }
    }
    .label1 {
      position: absolute;
      top: 40px;
    }
  }
  .rightCon {
    padding: 40px 0 0 300px;
    .mainBtn {
      margin: 30px 0 0 310px;
    }
  }
}

/* 客户筛查排版样式 */
.filter-row {
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  .filter-title {
    width: 120px;
    flex-shrink: 0;
  }
  .split-line {
    color: #666;
  }
  .el-input-number {
    width: 140px;
  }
}
.w300 {
  width: 300px;
}
</style>